import { setSideBarShow } from '../../store/workspace/slice';
import { useDispatch, useSelector } from '../../store/store';
import { ReactNode, useEffect, useRef } from 'react';
import { useLocation } from "react-router-dom";
import styles from './style.module.scss';
import SideBar from './SideBar';
import Header from './Header';
import {
    selectSideBarShow,
    selectJobDetailStep,
    selectSideBarExpanded,
} from "../../store/workspace/selectors";

interface Props {
    children: ReactNode;
};

function WorkspaceLayout(props: Props) {
    const { children } = props;
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const ref = useRef<HTMLDivElement | null>(null);
    const sideBarShow = useSelector(selectSideBarShow);
    const jobDetailStep = useSelector(selectJobDetailStep);
    const sideBarExpanded = useSelector(selectSideBarExpanded);

    useEffect(() => {
        setTimeout(() => {
            ref.current?.scrollTo({ top: 0, behavior: 'smooth' })
        }, 0);
    }, [pathname, jobDetailStep]);

    const handleClick = () => {
        if (!sideBarShow) return;
        dispatch(setSideBarShow(false));
    };

    return (
        <div
            onClick={handleClick}
            className={styles.container}
            data-sidebar-expanded={sideBarExpanded}
        >
            <Header />
            <SideBar show={sideBarShow} />
            <div className={styles.child} ref={ref}>{children}</div>
        </div>
    );
};

export default WorkspaceLayout;
